import { ANDROID_PHONE_REGEX } from '../constants/constants';

export default {
	bind: function (el, binding) {
		if (ANDROID_PHONE_REGEX.test(navigator.userAgent)) {
			el.setAttribute('href', binding.value);
		}
	}
};
